import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Logoslider = () => {
      const logos1 = [
        '/assets/images/clients/L1.jpg',
        '/assets/images/clients/L2.jpg',
        '/assets/images/clients/L3.jpg',
        '/assets/images/clients/L4.jpg',
        '/assets/images/clients/L5.jpg',
        '/assets/images/clients/L6.jpg',
        '/assets/images/clients/L7.jpg',
        '/assets/images/clients/L8.jpg',
        '/assets/images/clients/L9.jpg',
        '/assets/images/clients/L10.jpg',
        '/assets/images/clients/L11.jpg',
        '/assets/images/clients/L12.jpg',
        '/assets/images/clients/L13.jpg',
        '/assets/images/clients/L14.jpg',
        '/assets/images/clients/L15.jpg',
        '/assets/images/clients/L16.jpg',
        '/assets/images/clients/L17.jpg',
      ];

      const logos2 = [
        '/assets/images/clients/L18.jpg',
        '/assets/images/clients/L19.jpg',
        '/assets/images/clients/L20.jpg',
        '/assets/images/clients/L21.jpg',
        '/assets/images/clients/L22.jpg',
        '/assets/images/clients/L23.jpg',
        '/assets/images/clients/L24.jpg',
        '/assets/images/clients/L25.jpg',
        '/assets/images/clients/L26.jpg',
        '/assets/images/clients/L27.jpg',
        '/assets/images/clients/L28.jpg',
        '/assets/images/clients/L29.jpg',
        '/assets/images/clients/L30.jpg',
        '/assets/images/clients/L31.jpg',
        '/assets/images/clients/L32.jpg',
        '/assets/images/clients/L33.jpg',
        '/assets/images/clients/L34.jpg',
      ];

      const logos3 = [
        '/assets/images/clients/L35.jpg',
        '/assets/images/clients/L36.jpg',
        '/assets/images/clients/L37.jpg',
        '/assets/images/clients/L38.jpg',
        '/assets/images/clients/L39.jpg',
        '/assets/images/clients/L40.jpg',
        '/assets/images/clients/L41.jpg',
        '/assets/images/clients/L42.jpg',
        '/assets/images/clients/L43.jpg',
        '/assets/images/clients/L44.jpg',
        '/assets/images/clients/L45.jpg',
        '/assets/images/clients/L46.jpg',
        '/assets/images/clients/L47.jpg',
        '/assets/images/clients/L48.jpg',
        '/assets/images/clients/L49.jpg',
        '/assets/images/clients/L50.jpg',
        '/assets/images/clients/L51.jpg',
        '/assets/images/clients/L52.jpg',
      ];

      const settings = {
        dots: false,
        infinite: true,
        speed: 800,
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000,
        arrows: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 3,
            },
          },
        ],
      };

      const settingsTwo = {
        dots: false,
        infinite: true,
        speed: 800,
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000,
        arrows: false,
        rtl: true,

        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 3,
            },
          },
        ],
      };
      
      const settingsThree = {
        dots: false,
        infinite: true,
        speed: 800,
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000,
        arrows: false,

        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 3,
            },
          },
        ],
      };

  return (
    <div className='pt-4 logo-slider-wrapper'>
        <h3 className="pb-4 myfont1 fw-bold">Companies Where Our Engineers Are Placed..!</h3>
      <Slider {...settings} className='ms-2 me-2 slickslidermargin' >
        {logos1.map((logo, index) => (
          <div key={index}>
            <img
              src={logo}
              alt="Client company logo"
              style={{ width: '80%', height: '80px', objectFit: 'contain' }}
              loading="lazy"
            />
          </div>
        ))}
      </Slider>

      <Slider {...settingsTwo} className='ms-2 me-2 slickslidermargin'>
        {logos2.map((logo, index) => (
          <div key={index} style={{ padding: '40px' }}>
            <img
              src={logo}
              alt="Client company logo"
              style={{ width: '80%', height: '80px', objectFit: 'contain' }}
              loading="lazy"
            />
          </div>
        ))}
      </Slider>

      <Slider {...settingsThree} className='ms-2 me-2 slickslidermargin'>
        {logos3.map((logo, index) => (
          <div key={index} style={{ padding: '40px' }}>
            <img
              src={logo}
              alt="Client company logo"
              style={{ width: '80%', height: '80px', objectFit: 'contain' }}
              loading="lazy"
            />
          </div>
        ))}
      </Slider>

            <style>{`
        .logo-slider-wrapper {
          position: relative;
        }

        .slick-prev,
        .slick-next {
          z-index: 2;
          top: 50%;
          transform: translateY(-50%);
        }

        .slick-prev {
          left: 0px;
        }

        .slick-next {
          right: 1%;
        }

        .slick-prev:before,
        .slick-next:before {
          color: #0d6efd !important;
          font-size: 30px;
        }
      `}</style>
    </div>
  );
}

export default Logoslider